import { render, staticRenderFns } from "./BeeQuantityLabel.vue?vue&type=template&id=03f43172"
import script from "./BeeQuantityLabel.vue?vue&type=script&lang=js"
export * from "./BeeQuantityLabel.vue?vue&type=script&lang=js"
import style0 from "./BeeQuantityLabel.vue?vue&type=style&index=0&id=03f43172&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports